import { BASE_URL } from "../utils/BaseUrl"
import httpRequest from "../utils/httpsRequest";

export const AddFoods = async (payload) => {
  return await httpRequest(`${BASE_URL}/Foods`, "post", payload );
}
export const EditFood = async (payload) => {
  return await httpRequest(`${BASE_URL}/Foods`, "put", payload );
}
export const DeleteFood = async (payload) => {
  return await httpRequest(`${BASE_URL}/Foods/${payload}`, "delete" );
}